const DEFAULT_FIRST_DAY = 1;
function getFirstDayOfTheWeek(locale) {
  try {
    const intlLocale = new Intl.Locale(locale);
    if (intlLocale.getWeekInfo) {
      const weekInfo = intlLocale.getWeekInfo();
      const firstDay = weekInfo.firstDay;
      if (firstDay !== void 0) {
        return firstDay === 7 ? 0 : firstDay;
      }
    }
    return getFirstDayManual(locale);
  } catch {
    return getFirstDayManual(locale);
  }
}
const REGIONS_STARTING_SATURDAY = ["AF", "BH", "DJ", "DZ", "EG", "IQ", "IR", "JO", "KW", "LY", "OM", "QA", "SD", "SY"];
const REGIONS_STARTING_SUNDAY = ["AG", "AS", "BD", "BR", "BS", "BT", "BW", "BZ", "CA", "CO", "DM", "DO", "ET", "GT", "GU", "HK", "HN", "ID", "IL", "IN", "IS", "JM", "JP", "KE", "KH", "KR", "LA", "MH", "MM", "MO", "MT", "MX", "MZ", "NI", "NP", "PA", "PE", "PH", "PK", "PR", "PT", "PY", "SA", "SG", "SV", "TH", "TT", "TW", "UM", "US", "VE", "VI", "WS", "YE", "ZA", "ZW"];
const LANGUAGES_STARTING_SATURDAY = ["ar"];
const LANGUAGES_STARTING_SUNDAY = ["en", "he", "hi", "id", "ja", "ko", "pt", "tl", "th"];
function getFirstDayManual(locale) {
  try {
    const intlLocale = new Intl.Locale(locale);
    const language = intlLocale.language?.toLowerCase();
    const region = intlLocale.region?.toUpperCase();
    if (region) {
      if (REGIONS_STARTING_SUNDAY.includes(region)) {
        return 0;
      }
      if (REGIONS_STARTING_SATURDAY.includes(region)) {
        return 6;
      }
      return DEFAULT_FIRST_DAY;
    }
    if (language) {
      if (LANGUAGES_STARTING_SUNDAY.includes(language)) {
        return 0;
      }
      if (LANGUAGES_STARTING_SATURDAY.includes(language)) {
        return 6;
      }
    }
    return DEFAULT_FIRST_DAY;
  } catch {
    return DEFAULT_FIRST_DAY;
  }
}
export {
  getFirstDayOfTheWeek
};
//# sourceMappingURL=get-first-day-of-the-week.js.map
